import Fuse from 'fuse.js';
import { mutationTypes } from '../../../types';
import actions from './actions/index';

import { catchFocus } from '../../../tools/helpers';
import { SEARCH_SCOPES } from '../../../tools/consts';
const scopeNames = Object.values(SEARCH_SCOPES);
const defaultOptions = { closeButton: true, setFocus: false, hideEmptyResult: false };
export default {
	state: {
		scopes: scopeNames.reduce((acc, name) => {
			acc[name] = {
				data: [],
				subData: [],
				timestamp: null,
				searchOptions: {},
				refresh: null,
				query: '',
				resetFilter: null,
				alterationFunctions: [],
				options: defaultOptions,
			};
			return acc;
		}, {}),
		currentScope: null,
	},
	getters: {
		...scopeNames.reduce((acc, scopeName) => {
			acc[`${scopeName}SearchResults`] = state => {
				const { query, data, options, searchFunction } = state.scopes[scopeName];

				let result = null;

				if (searchFunction && query) {
					result = searchFunction.search(query);
				}

				if (!result) {
					// shows only results if query != empty string
					result = options.hideEmptyResult ? [] : data;
				}

				return result;
			};
			return acc;
		}, {}),

		...scopeNames.reduce((acc, scopeName) => {
			acc[`${scopeName}AlteredSearchResults`] = (state, { [`${scopeName}SearchResults`]: results }) => {
				const { alterationFunctions } = state.scopes[scopeName];

				return alterationFunctions.reduce((alteredAcc, fn) => fn(alteredAcc), [...results]);
			};

			return acc;
		}, {}),
	},
	mutations: {
		[mutationTypes.searchSetData](
			state,
			{
				data,
				subData,
				scope,
				searchOptions,
				refresh,
				resetFilter,
				alterationFunctions,
				timestamp,
				options = { closeButton: true, setFocus: false, hideEmptyResult: false },
			}
		) {
			const scopeState = {
				...state.scopes[scope],
				data: [...data],
				subData: subData ? [...subData] : [],
				searchOptions,
				refresh,
				resetFilter,
				options: Object.assign({}, defaultOptions, options),
				timestamp: timestamp ? timestamp : Date.now(), // If there is no timestamp of new data, take current time
				// Clear search on reopneing.
				searchFunction: new Fuse(data, searchOptions),
				searchSubFunction: new Fuse(subData, searchOptions),
				// Functions will be called on the query result like sorting or sperators adding.
				alterationFunctions: alterationFunctions || [],
			};

			state.scopes = {
				...state.scopes,
				[scope]: scopeState,
			};

			state.currentScope = scope;
			if (options.setFocus) {
				// has to behandled here cause of click focus restricitons on mobile devices
				catchFocus();
			}
		},
		[mutationTypes.searchQuery](state, { scope, query }) {
			state.scopes[scope].query = query;
		},
	},
	actions,
	plugins: [],
};
